var _path, _path2, _g, _path3, _path4, _g2, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuantica(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 48,
    viewBox: "0 0 141 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_819_479",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 48
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.42055 15.6382C-2.42528 28.0587 -1.18253 41.8711 7.19617 46.4893C15.5749 51.1074 27.9169 44.7823 34.7626 32.3618C41.6084 19.9413 40.3657 6.12879 31.9869 1.51073C30.128 0.486156 28.0726 0.000244141 25.9268 0C18.4009 -0.000740051 9.74751 5.97335 4.42055 15.6382ZM7.32661 39.5501C1.38176 36.2734 0.755358 26.01 5.92745 16.6261C11.0996 7.24215 20.1117 2.29126 26.0566 5.56778C32.0014 8.84444 32.6278 19.1078 27.4557 28.4918C23.3657 35.9123 16.8743 40.5608 11.3974 40.5609C9.94829 40.561 8.57041 40.2356 7.32661 39.5501Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_819_479)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_819_479",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -2055,
    y: -1937,
    width: 4044,
    height: 4045
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-2054.78 -1936.13H1988.9V2107.54H-2054.78V-1936.13Z",
    fill: "url(#paint0_linear_819_479)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_819_479)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.42055 15.6382C-2.42528 28.0587 -1.18253 41.8711 7.19617 46.4893C15.5749 51.1074 27.9169 44.7823 34.7626 32.3618C41.6084 19.9413 40.3657 6.12879 31.9869 1.51073C30.128 0.486156 28.0726 0.000244141 25.9268 0C18.4009 -0.000740051 9.74751 5.97335 4.42055 15.6382ZM7.32661 39.5501C1.38176 36.2734 0.755358 26.01 5.92745 16.6261C11.0996 7.24215 20.1117 2.29126 26.0566 5.56778C32.0014 8.84444 32.6278 19.1078 27.4557 28.4918C23.3657 35.9123 16.8743 40.5608 11.3974 40.5609C9.94829 40.561 8.57041 40.2356 7.32661 39.5501Z",
    fill: "url(#paint1_linear_819_479)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_819_479",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 17,
    width: 25,
    height: 26
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7671 19.6027C17.1612 22.9293 18.5737 30.326 23.9223 36.1238C29.2708 41.9215 36.5298 43.9248 40.1358 40.5983C43.5447 37.4536 42.4842 30.6916 37.8379 25.0616C37.6556 25.6695 37.4464 26.305 37.228 26.9176C40.0383 30.7128 40.8937 34.6929 39.0721 36.3732C36.9709 38.3117 32.0952 36.4446 28.1822 32.2029C24.2692 27.9612 22.8005 22.951 24.9018 21.0126C26.0732 19.9319 28.0899 20.0266 30.3384 21.0634C30.4745 20.4838 30.5777 19.9156 30.6772 19.3359C28.8213 18.4592 26.9707 17.9977 25.2957 17.9976C23.5231 17.9975 21.947 18.5142 20.7671 19.6027Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_819_479)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_819_479",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -2055,
    y: -1937,
    width: 4044,
    height: 4045
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-2054.78 -1936.13H1988.9V2107.54H-2054.78V-1936.13Z",
    fill: "url(#paint2_linear_819_479)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_819_479)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7674 19.6027C17.1614 22.9293 18.574 30.326 23.9225 36.1238C29.271 41.9215 36.5301 43.9248 40.136 40.5983C43.5449 37.4536 42.4844 30.6916 37.8382 25.0616C37.6558 25.6695 37.4467 26.305 37.2282 26.9176C40.0385 30.7128 40.8939 34.6929 39.0724 36.3732C36.9711 38.3117 32.0954 36.4446 28.1825 32.2029C24.2694 27.9612 22.8007 22.951 24.902 21.0126C26.0735 19.9319 28.0902 20.0266 30.3387 21.0634C30.4747 20.4838 30.5779 19.9156 30.6774 19.3359C28.8215 18.4592 26.971 17.9977 25.296 17.9976C23.5234 17.9975 21.9472 18.5142 20.7674 19.6027Z",
    fill: "url(#paint3_linear_819_479)"
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1511 30.556C65.4166 29.7846 65.0493 28.7531 65.0493 27.4621V20.6958H67.2974V27.3731C67.2974 29.0796 68.1504 29.9327 69.857 29.9327C71.3556 29.9327 72.528 29.2577 73.3737 27.9073V20.6958H75.6218V31.3795H73.4405V29.8659C72.9359 30.5041 72.3387 30.9715 71.6488 31.2682C70.9588 31.5649 70.2131 31.7134 69.4119 31.7134C67.9724 31.7134 66.8856 31.3277 66.1511 30.556Z",
    fill: "#302959"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5024 29.5766C85.0812 29.2949 85.5113 28.9016 85.7934 28.3969V26.9502C84.8287 26.3269 83.753 26.0154 82.566 26.0154C81.7053 26.0154 81.0636 26.1823 80.6407 26.5162C80.2178 26.85 80.0064 27.3585 80.0064 28.0408C80.0064 29.3467 80.8595 29.9995 82.566 29.9995C83.2783 29.9995 83.9237 29.8587 84.5024 29.5766ZM78.9046 30.7229C78.1256 30.0628 77.7361 29.1686 77.7361 28.0408C77.7361 26.8539 78.1107 25.9375 78.8601 25.292C79.6092 24.6465 80.6741 24.3238 82.0541 24.3238C83.5231 24.3238 84.7696 24.6208 85.7934 25.2141V24.6576C85.7934 23.8118 85.5374 23.1852 85.0256 22.7769C84.5136 22.3689 83.7085 22.1648 82.6105 22.1648C81.9574 22.1648 81.3231 22.228 80.7075 22.354C80.0916 22.4802 79.539 22.6544 79.0493 22.877V21.0519C79.4944 20.8443 80.0731 20.6773 80.7854 20.5511C81.4977 20.4252 82.1876 20.3619 82.8554 20.3619C84.621 20.3619 85.9304 20.7514 86.7839 21.5304C87.637 22.3095 88.0637 23.389 88.0637 24.7689V31.3795H85.9492V30.1775C85.4891 30.6822 84.9438 31.0644 84.3133 31.3239C83.6824 31.5832 82.9145 31.7134 82.0096 31.7134C80.7187 31.7134 79.6837 31.383 78.9046 30.7229Z",
    fill: "#302959"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8455 20.6957H93.0267V22.2314C93.531 21.5936 94.1507 21.1224 94.8852 20.8181C95.6198 20.5141 96.3876 20.3618 97.1889 20.3618C98.6134 20.3618 99.6742 20.7402 100.372 21.4969C101.069 22.2537 101.418 23.2703 101.418 24.5463V31.3794H99.1699V24.7688C99.1699 23.0327 98.3387 22.1647 96.677 22.1647C95.9647 22.1647 95.3005 22.3316 94.6849 22.6655C94.069 22.9993 93.5387 23.5078 93.0935 24.1901V31.3794H90.8455V20.6957Z",
    fill: "#302959"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M105.814 30.7785C105.227 30.1553 104.935 29.2727 104.935 28.1299V22.4319H103.31V20.6958H104.935V17.4906H107.205V20.6958H109.831V22.4319H107.205V27.974C107.205 28.6863 107.342 29.1909 107.617 29.4876C107.891 29.7846 108.392 29.9327 109.119 29.9327C109.549 29.9327 109.979 29.8364 110.41 29.6434V31.424C109.846 31.6167 109.149 31.7134 108.318 31.7134C107.234 31.7134 106.4 31.4018 105.814 30.7785Z",
    fill: "#302959"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M112.702 20.6957H114.995V31.3794H112.702V20.6957ZM112.903 18.225C112.65 17.9729 112.524 17.6613 112.524 17.2902C112.524 16.9195 112.65 16.6079 112.903 16.3554C113.155 16.1033 113.466 15.977 113.837 15.977C114.223 15.977 114.546 16.1033 114.806 16.3554C115.065 16.6079 115.195 16.9195 115.195 17.2902C115.195 17.6613 115.065 17.9729 114.806 18.225C114.546 18.4775 114.223 18.6034 113.837 18.6034C113.466 18.6034 113.155 18.4775 112.903 18.225Z",
    fill: "#302959"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M120.559 31.0456C119.639 30.6005 118.923 29.9515 118.411 29.0981C117.9 28.245 117.644 27.2323 117.644 26.0599C117.644 24.8879 117.9 23.8752 118.411 23.0217C118.923 22.1686 119.643 21.512 120.57 21.0519C121.498 20.5922 122.563 20.3619 123.764 20.3619C125.397 20.3619 126.703 20.6812 127.682 21.319V23.1664C126.717 22.4987 125.486 22.1648 123.987 22.1648C122.77 22.1648 121.787 22.4952 121.038 23.1553C120.288 23.8157 119.914 24.7839 119.914 26.0599C119.914 27.3363 120.285 28.3006 121.027 28.9534C121.769 29.6065 122.741 29.9328 123.943 29.9328C125.441 29.9328 126.732 29.5766 127.815 28.8644V30.6895C127.296 31.0456 126.706 31.3054 126.046 31.4685C125.385 31.6317 124.61 31.7134 123.72 31.7134C122.533 31.7134 121.479 31.4908 120.559 31.0456Z",
    fill: "#302959"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M136.474 29.5766C137.053 29.2949 137.483 28.9016 137.765 28.3969V26.9502C136.8 26.3269 135.724 26.0154 134.537 26.0154C133.677 26.0154 133.035 26.1823 132.612 26.5162C132.189 26.85 131.978 27.3585 131.978 28.0408C131.978 29.3467 132.831 29.9995 134.537 29.9995C135.25 29.9995 135.895 29.8587 136.474 29.5766ZM130.876 30.7229C130.097 30.0628 129.708 29.1686 129.708 28.0408C129.708 26.8539 130.082 25.9375 130.832 25.292C131.581 24.6465 132.646 24.3238 134.026 24.3238C135.495 24.3238 136.741 24.6208 137.765 25.2141V24.6576C137.765 23.8118 137.509 23.1852 136.997 22.7769C136.485 22.3689 135.68 22.1648 134.582 22.1648C133.929 22.1648 133.295 22.228 132.679 22.354C132.063 22.4802 131.51 22.6544 131.021 22.877V21.0519C131.466 20.8443 132.045 20.6773 132.757 20.5511C133.469 20.4252 134.159 20.3619 134.827 20.3619C136.592 20.3619 137.902 20.7514 138.755 21.5304C139.608 22.3095 140.035 23.389 140.035 24.7689V31.3795H137.921V30.1775C137.461 30.6822 136.915 31.0644 136.285 31.3239C135.654 31.5832 134.886 31.7134 133.981 31.7134C132.69 31.7134 131.655 31.383 130.876 30.7229Z",
    fill: "#302959"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0377 25.1692C52.0377 22.5617 54.0349 20.4479 56.4986 20.4479C58.9623 20.4479 60.9595 22.5617 60.9595 25.1692C60.9595 25.8876 60.8072 26.5681 60.536 27.1778L59.2107 25.5908L57.4987 27.0205L59.1336 28.9782C58.3953 29.5514 57.4845 29.8906 56.4986 29.8906C54.0349 29.8906 52.0377 27.7768 52.0377 25.1692ZM63.9624 29.8198L62.1024 28.6621C62.7893 27.6578 63.19 26.4585 63.19 25.1692C63.19 21.6378 60.1941 18.775 56.4986 18.775C52.8031 18.775 49.8073 21.6378 49.8073 25.1692C49.8073 28.7007 52.8031 31.5634 56.4986 31.5634C57.9999 31.5634 59.3856 31.091 60.502 30.2932L62.7838 31.7134L63.9624 29.8198Z",
    fill: "#302959"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_819_479",
    x1: 7.35531,
    y1: 15.0689,
    x2: 30.2082,
    y2: 31.748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.299992
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_819_479",
    x1: 7.35512,
    y1: 15.0692,
    x2: 30.208,
    y2: 31.7484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0092DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0092DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_819_479",
    x1: 44.6522,
    y1: 19.4708,
    x2: 25.9492,
    y2: 33.4708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_819_479",
    x1: 44.6522,
    y1: 19.471,
    x2: 25.9491,
    y2: 33.471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57248B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57248B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuantica);
export default __webpack_public_path__ + "static/media/quantica.7e3399a83c06a92e40442471645335bf.svg";
export { ForwardRef as ReactComponent };